import { Component } from 'preact';
import style from './styles/ShippingPage.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LoadingSpinner from '../../components/spinner/LoadingSpinner';
import Layout from '../../components/Layout';
import DeliveryRepository from '../../repositories/DeliveryRepository';
import ShippingTable from '../../components/blocks/shippingPage/ShippingTable';
import MetaTags from "react-meta-tags";

/**
 * @property {Object[]} props.countries
 * @property {boolean} props.fetchingCountries
 */
// eslint-disable-next-line react/prefer-stateless-function
class ShippingPage extends Component {

	static fetchData(store, match) {
		return [
			store.dispatch(DeliveryRepository.fetchShippingTable())
		];
	}

	static getHtmlHeadFragment() {
		return '<title>Footshop - Releases</title><meta name="description" content=""/><meta name="robots" content="index, follow">';
	}

	componentDidMount() {
		this.props.fetchShippingTable();
	}

	render({ route, location, countries, fetchingCountries }) {
		if (fetchingCountries || countries === null) {
			return (
				<Layout {...{ route, location }}>
					<div className="abs-vertical-center">
						<LoadingSpinner active />
					</div>
				</Layout>
			);
		}

		return (
			<Layout {...{ route, location, offsetDesktopHeader: true }} >
				<MetaTags>
					<title>{route.metaTitle}</title>
					<meta name="description" content=""/>
				</MetaTags>
				<div className={`container ${style.content}`}>
					<div className="row">
						<div className={`col-sm-12 mb-3`}>
							<h1 className={style.title}>DELIVERY GLOBAL SHIPPING</h1>
							<div className={'alert alert-warning'}>
								If your delivery country charges customs or import duties from the EU, you will have to pay these charges. Unfortunately, we have no control over them and cannot inform you of what they will be. Customs policies vary from country to country so if you have any questions, please contact your local customs office for more info.
							</div>
							<div className="table-responsive">
								<ShippingTable {...{ countries }} />
							</div>
						</div>
					</div>
				</div>
			</Layout>
		);
	}
}

const mapStateToProps = (state) => {
	const { shippingPage } = state;
	return {
		fetchingCountries: shippingPage.fetchingCountries,
		countries: shippingPage.countries
	};
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
	fetchShippingTable: DeliveryRepository.fetchShippingTable
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ShippingPage);



// WEBPACK FOOTER //
// ./routes/shipping/ShippingPage.js